import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Image from "../Image";
import styles from "./Embed.css";

class Embed extends Component {

  renderEmbed = (oembed, type) => {
    let embedHtml = null;
    let isFullbleed = oembed.is_fullbleed;
    let embedAspectRatio;
    if (oembed.height && oembed.width) {
      // if there's a width and height, then create a placeholder
      embedAspectRatio = oembed.height / oembed.width;
    }
    if (type === "jwplayer-video") {
      // JW player's metadata includes some, but not all of the controls' height
      // Hardcoding the height, 44px, ensures controls are always visible
      embedAspectRatio = ((oembed.height + 44) / oembed.width);
    }
    if (type === "youtube" || type === "jwplayer-video") {
      // Youtube and JW Player videos should stretch edge-to-edge
      // The following boolean adds a CSS classname to do that
      isFullbleed = true;
    }
    if (oembed.type === "photo") {
      embedHtml = (
        <figure>
          <Image block={{ data: { image_id: this.props.block.key, src: oembed.url, alt_text: oembed.title } }}>
            {this.props.children}
          </Image>
        </figure>
      );
    } else {
      embedHtml = (
        <figure>
          <div
            className={classNames(
              styles.embedContainer,
              embedAspectRatio ? styles.responsiveIframe : {},
              isFullbleed ? styles.fullBleed : {},
              `block-${this.props.block.key}`
            )}
            style={embedAspectRatio && { paddingBottom: `${embedAspectRatio * 100}%` }}
            dangerouslySetInnerHTML={{ __html: oembed.html }}
          />
          <figcaption className={type !== "axios-visual" && styles.hide}>{this.props.children}</figcaption>
        </figure>
      );
    }
    return embedHtml;
  };

  render() {
    const { oembed, type } = this.props.block.data;
    if (!oembed) return null;

    return (
      <div className={styles.root}>
        {this.renderEmbed(oembed, type)}
      </div>
    );
  }
}

Embed.propTypes = {
  block: PropTypes.object.isRequired,
};

export default Embed;



// WEBPACK FOOTER //
// ./src/components/Library/Embed/Embed.js